module.exports = __webpack_public_path__ + "img/c-1.464a661e.png";